import React from "react";
import "./Banner.css";
// import { Button } from "@material-ui/core";
// import Search from "../../Search";
// import { useHistory } from "react-router-dom";
import AwesomeSlider from "react-awesome-slider";
import "react-awesome-slider/dist/styles.css";
import "./awesome-slider-override.css";
import withAutoplay from "react-awesome-slider/dist/autoplay";

import axios from "../../services/axios";

import { useState, useEffect } from "react";

// const AutoplaySlider = withAutoplay(AwesomeSlider);

const Banner = (props) => {
  const AutoplaySlider = withAutoplay(AwesomeSlider);
  const [slides, setSlides] = useState([]);
  // console.log("Props::" + props.lang);
  // this use effect triggers when lang change
  useEffect(() => {
    async function fetchData() {
      try {
        const request = await axios.get(`/banner/lang/${props.lang}`);
        setSlides(request.data);
        // console.log("slides::" + request.data);
        return request;
      } catch (error) {
        if (error.response?.status === 401) {
          //history.push('/login');
        }
      }
    }
    fetchData();
  }, [props.lang]);

  // const history = useHistory();
  // const [showSearch, setShowSearch] = useState(false);

  if (slides != null) {
    console.log("slides render");
    return (
      <div className="banner">
        <AutoplaySlider
          play={true}
          interval={slides.velocitySlide}
          bullets={true}
          cancelOnInteraction={false}
          fillParent={false}
        >
          {slides?.listMetaDataMedia?.map((slide) => (
            <div
              key={slide?.assetId}
              className="big-image"
              style={{
                backgroundImage: "url(" + `${slide?.coverUrl}` + ")",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            >
              <div
                className="overlay2"
                style={{
                  background: "rgba(0, 0, 0," + slide?.overlayBLack + ")",
                }}
              >
                {" "}
              </div>
              <div className="text">
                <p className="text-title">{slide?.principalText} </p>
                <p className="big-image-p">{slide?.secondaryText}</p>
                <div className="banner_button_container">
                  <a
                    href={`${slide?.buttonLinkOne}`+'&rd='+encodeURI('https://tncdigital.cat/educatiuprofessionals/response/')}
                    style={{ backgroundColor: `${slide?.buttonColorOne}` }}
                  >
                    {slide?.textButtonOne}
                  </a>
                 { /*<a
                    href={`${slide?.buttonLinkTwo}`}
                    style={{ backgroundColor: `${slide?.buttonColorTwo}` }}
                  >
                    {slide?.textButtonTwo}
                 </a>*/}
                </div>
              </div>
            </div>
          ))}
        </AutoplaySlider>
      </div>
    );
  } else {
  }
};

export default Banner;
